module.exports = __webpack_public_path__ + "img/NI.16149a24.svg";